import { Group as RacGroup, NumberField } from 'react-aria-components';
import styled, { css } from 'styled-components';

const shared = css`
  background: inherit;
  border: 0;
`;

export const Field = styled(NumberField)`
  width: 104px;
  height: 48px;
  border: 1px solid var(--grey-400);
  border-radius: var(--radius-base);
  box-shadow: var(--shadow-xs);

  &:has([data-focus-visible]) {
    box-shadow: var(--shadow-focus);
    border: 1px solid var(--brand-600);
  }
`;

export const Group = styled(RacGroup)`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  font-weight: var(--font-weight-bold);
  color: var(--black);

  & button {
    ${shared}

    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 48px;

    & svg {
      width: 12px;

      &[data-icon='trash'] {
        width: 16px;
      }

      & path {
        stroke: var(--black);
      }
    }

    &[data-disabled] path {
      stroke: var(--grey-400);
    }
  }

  & input {
    ${shared}

    width: 40px;
    text-align: center;
    font-size: var(--font-size-text-md);
    font-weight: var(--font-weight-medium);

    &[data-focus-visible] {
      outline: 0;
    }

    &[data-focused] {
      outline: 0;
    }
  }
`;
